<template>
  <div class="h-full">
    <viewer-page-design ref="refViewerPageDesign"
      :entity-id="solarPlantId"
      :entity-type="'solar-plant'"
      :work-layer="workLayer"
      :binary-only="true"
      :can-actions-pictogram="canActionsPictogram"/>
  </div>
</template>

<script>
import ViewerPageDesign from '../../components/pictograms/solar-park/views/ViewerPageDesign.vue';
export default {
  middleware: "auth",
  title: "solar-plant",

  components: {
    ViewerPageDesign
  },

  props: {

  },

  // data: () => ({
  data() {
    return {
      solarPlantId: null,
      workLayer: null, // // capa donde  trabajará el usuario, solo permite trabajar en esa capa si null trabaja en todas
      canActionsPictogram: {
        'show_header': true,
        'save': true,
        'select_entity': true,
        'show_areas': true,
        'show_insert': false,
        'show_screenshot': true,
        'show_design_mode': false,
        'show_back': true,
      }
    }
  },

  mounted() {

  },

  created () {
    this.workLayer = this.$route.params.wl // wl = worklayer
    this.solarPlantId = parseInt(this.$route.params.solarPlantId) ?? null;
  },


  methods: {

  }
};
</script>
